import { useState } from 'react';
import { LoggedUser } from '../models/user.model';
import { PROFILE_ADMIN_CODE } from '../assets/appConstants/constants';


export default function useUser() {
  const getUser = () => {
    const userString = localStorage.getItem('currentUser');
    if (userString) {
      const user = JSON.parse(userString);
      return user;
    } else {
      return null;
    }
  };

  const [user, setUser] = useState<LoggedUser>(getUser());
  const userAdmin: boolean = user?.profile_code === PROFILE_ADMIN_CODE

  const saveUser = (user: any) => {
    localStorage.setItem('currentUser', JSON.stringify(user));
    setUser(user);
  };

  return {
    setUser: saveUser,
    user,
    userAdmin
  };
}